/**
 * 获取首页数据
 */
import request from "_private/utils/request";

/* 广州市城市冷链配送监控看板 */

// 城市冷链配送企业排行
export function getComparyVehicleOrderNew(data) {
  return request({
    url: "/board/guangzhouMonitor/getComparyVehicleOrderNewDry",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取运营走势数据
export function fetchCenterLeftData(data) {
  return request({
    url: `/board/guangzhouMonitor/getOperatingTrendDry?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 城市冷链配送车辆24小时运营走势
export function getOperatingTrendForYesterday(data) {
  return request({
    url: " /board/guangzhouMonitor/getOperatingTrendForYesterdayDry",
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州市限行区域晚高峰冷藏车运行情况（A,B,C）
export function getStorageTonnageOrderNew(data) {
  return request({
    url: "/board/guangzhouMonitor/getStorageTonnageOrderNewDry",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取城市冷链配送车辆使用率及限行区域行驶数据
export function getBottomLeftData(data) {
  return request({
    url: `/board/guangzhouMonitor/vehicleUtilizationRateDry?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 进入广州重点限行区域情况
export function getKeyRestrictAreaInfo(data) {
  return request({
    url: "/board/guangzhouMonitor/getKeyRestrictAreaInfoDry",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 车辆、企业等汇总数据
export function fetchMapData(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findMapLonLatDry?transType=5",
    data
  });
}
// 实时查询各区县下企业、车辆、冷库、冷柜个数接口
export function FetchNumberByAreaName(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findNumberByAreaNameDry?transType=5",
    data
  });
}
// 广州市冷链配送企业排行
export function getComparyVehicleOrderNewForCity(data) {
  return request({
    url: `/board/guangzhouMonitor/getComparyVehicleOrderNewForCity?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 指定区域进出次数Top5
export function getInOutAreaFlow(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getInOutAreaFlow?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州冷配企业与物流节点关联度排行
export function getCompanyAndInOutAreaFlow(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getCompanyAndInOutAreaFlow?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州市范围内的冷藏车在线数量
export function getGuangZhouRunVehicleCount(data) {
  return request({
    url: `/board/guangzhouColdMonitor/getGuangZhouRunVehicleCount?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 雷达图数据
export function getFlowMapData(data) {
  return request({
    url: `/reserve/vehicle/getMapData`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
